import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from "rxjs/operators";
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';

import { environment } from "src/environments/environment";

import { FvmsApiAuthService } from "src/app/shared/service/fvms.api.auth.service";
import { FvmsApiNoticeService } from "src/app/shared/service/fvms.api.notice.service";
import { FilterDateTime } from "src/app/shared/filter";

@Component({
  templateUrl: './auth.ext.login.component.html'
  ,providers: [DatePipe,FilterDateTime]
})
export class AuthExtLoginComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    public envName:string = environment.name;
    
    constructor(
        private modalService: NgbModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private router: Router
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.queryParamMap.subscribe(params => {
            // console.log("params",params);
            let xAccessToken = params.get("x-access-token");
            let unitId = params.get("unitId");
            if(xAccessToken){
                //http://localhost:8085/fvms/auth/ext/login/main?unitId=01229522504&x-access-token=eyJhbGciOiJIUzI1NiJ9.eyJpcEFjY2Vzc0RldmljZSI6IjYxLjM5LjE1NS4xOCIsInVzZXJHcm91cElkIjoiMTAwIiwiY29tcGFueUlkIjoiMiIsInRlYW1JZCI6IiIsInR5cGVBY2Nlc3NEZXZpY2UiOiIxIiwiZXhwIjoxNjQ3NTY1NjI3LCJ1c2VySWQiOiJ0ZXN0MDgiLCJhcGlUeXBlIjoic21pbGsifQ.HoqsBywzv1TksaaaAgRCW0u4gxGjc2NoQclxOQp9AsY
                this.fvmsApiAuthService.getIpAccessDevice()
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe(response => {
                        //console.log("getIpAccessDevice","subscribe",response);
                        if(response && response.ip){
                            let ipAccessDevice = response.ip;
                            this.fvmsApiAuthService.loginTokenCheck(xAccessToken,ipAccessDevice,"1")
                                .pipe(takeWhile(() => this.isContinue))
                                .subscribe(apiResponse => {
                                    if(apiResponse.resultStatus === "ok"){
                                        console.log("apiResponse",apiResponse);
                                        if(apiResponse.resultValue){
                                            // 로그인 정보 저장
                                            let userInfo = apiResponse.resultValue;
                                            userInfo["token"] = xAccessToken;
                                            userInfo["typeAccessDevice"] = "1";
                                            userInfo["showMapCluster"] = true
                                            userInfo["ipAccessDevice"] = ipAccessDevice;
                                            this.fvmsApiAuthService.setSessionUserInfo(apiResponse.resultValue,true);

                                            // url 이동
                                            let tmpParam = {
                                                runtime:new Date().getTime()
                                                ,unitId:unitId
                                            };
                                            let navigationExtras:NavigationExtras = {
                                                queryParams:tmpParam
                                                // ,fragment:"anchor"
                                            };
                                            switch(userInfo.apiType){
                                                case "dsdelivery":
                                                    // this.router.navigate(["/dtg/car/ext/current/list"],navigationExtras);
                                                    this.router.navigate(["/dtg/car/ext/current/drive/hist/list"],navigationExtras);
                                                    break;
                                                case "smilk":
                                                    // this.router.navigate(["/dtg/car/ext/current/list"],navigationExtras);
                                                    this.router.navigate(["/dtg/car/ext/current/drive/hist/list"],navigationExtras);
                                                    break;
                                                default:
                                                    // this.router.navigate(["/dtg/car/ext/current/list"],navigationExtras);
                                                    this.router.navigate(["/dtg/car/ext/current/drive/hist/list"],navigationExtras);
                                                    break;
                                            }
                                        }
                                    }
                                });
                        }
                    });
            }else{
                let tmpParam = {
                    runtime:new Date().getTime()
                };
                let navigationExtras:NavigationExtras = {
                    queryParams:tmpParam
                    ,fragment:"anchor"
                };
                this.router.navigate(["/fvms/auth/ext/err/e401/main"],navigationExtras);
            }
        });
    }

    ngOnInit() {
        this.fvmsApiAuthService.getIpAccessDevice()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                //console.log("getIpAccessDevice","subscribe",response);
                if(response && response.ip){
                    // this.formGroup.patchValue({
                    //     ipAccessDevice:response.ip
                    // });
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}
}